var map = {
	"./account-number.svg": 1239,
	"./account-star.svg": 1240,
	"./account.svg": 1241,
	"./angle_down.svg": 1242,
	"./angle_right_circle.svg": 1243,
	"./angle_up.svg": 1244,
	"./arrow_down.svg": 1245,
	"./arrow_left.svg": 1246,
	"./arrow_right.svg": 1247,
	"./arrow_up.svg": 1248,
	"./arrowdown2.svg": 1249,
	"./arrowup2.svg": 1250,
	"./back.svg": 1251,
	"./check-circle-fill.svg": 1252,
	"./check-circle.svg": 1253,
	"./check.svg": 1254,
	"./circle-line.svg": 1255,
	"./close-x.svg": 1256,
	"./close.svg": 1257,
	"./close_fill.svg": 1258,
	"./close_line.svg": 1259,
	"./contact.svg": 1260,
	"./current.svg": 1261,
	"./date.svg": 1262,
	"./defaultIcon.svg": 1263,
	"./default_image.svg": 1264,
	"./delete.svg": 1265,
	"./device.svg": 1266,
	"./disable.svg": 1267,
	"./dropdown.svg": 1268,
	"./edit.svg": 1269,
	"./file-ppt-fill.svg": 1270,
	"./file-unknown-fill.svg": 1271,
	"./file-video-fill.svg": 1272,
	"./file-word-fill.svg": 1273,
	"./lookup.svg": 1274,
	"./message-error.svg": 1275,
	"./message-success.svg": 1276,
	"./minus.svg": 1277,
	"./more.svg": 1278,
	"./notification.svg": 1279,
	"./orders_fill.svg": 1280,
	"./plus.svg": 1281,
	"./plus_bold.svg": 1282,
	"./save.svg": 1283,
	"./upload.svg": 1284,
	"./wrong-circle.svg": 1285
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1559;


//////////////////
// WEBPACK FOOTER
// ./~/vue-xpc/src/assets/icons/svgs nonrecursive ./~/rt-svg-sprite-loader/lib/loader.js?{"symbolId":"rt-base-[name]"}! .svg$
// module id = 1559
// module chunks = 91